import { FILE_TYPE } from 'utils/enums';

export const CHAT_FILE_TYPE_ACCEPT = [FILE_TYPE.IMAGE, FILE_TYPE.EXCEL];
